export default {
    'halls.loading': 'Loading',
    'halls.primary.title': 'Latihan',
    'halls.middle.title': 'Pakar',
    'halls.high.title': 'Mewah',
    'halls.top.title': 'Master',
    'halls.level.describe': 'Syarat Dewan',
    'halls.coin.not': 'Kekurangan koin',
    'halls.setting.title': 'Tetapan',
};